import { service_translate_generations } from '@/services/translate/SERVICE__translate_generations';
import { local_user_task_delete } from '@/state/generation/user_task/entity/local_user_task_delete';
import { LOCAL__grid2d_delete } from '@/state/grid2d/grid2d/LOCAL__grid2d_delete';
import { store } from '@/state/store';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { local_workspace_child_entity_child_viewer_delete_by_entity_data } from '../child_entity/local_workspace_child_entity_child_viewer_delete_by_entity_data';

export const on_workspace_child_entity_delete_user_task = (ids: string[]) => {
  let slice_generation = store.getState().slice_generation;

  let grid2d_ids: string[] = [];

  let generations_ids: string[] = [];

  for (let id of ids) {
    let user_task = slice_generation.user_tasks_map.get(id);

    //could be null if user is still not received tasks during auth
    if (!user_task) continue;

    let user_task_generations = Array.from(slice_generation.generations_map.values()).filter(item => item.user_task_id == id);

    generations_ids = user_task_generations.map(item => item._id);

    grid2d_ids.push(user_task._id);

    grid2d_ids = [...grid2d_ids, ...user_task_generations.map(item => item._id)];

    store.dispatch(
      local_workspace_child_entity_child_viewer_delete_by_entity_data(
        user_task_generations.map(item => ({ entity_id: item._id, entity_type: ENUM__workspace_entity.ENTITY_GENERATION })),
      ),
    );

    store.dispatch(
      local_workspace_child_entity_child_viewer_delete_by_entity_data([{ entity_id: user_task._id, entity_type: ENUM__workspace_entity.ENTITY_USER_TASK }]),
    );
  }

  store.dispatch(LOCAL__grid2d_delete(grid2d_ids));

  service_translate_generations.on_entities_deleted(generations_ids);

  store.dispatch(local_user_task_delete(ids));
};
